import Vue from 'vue';
import Router from 'vue-router';

import axios from 'axios';
import store from '@/stores';

import { getUserToken, extendTokenExpiration } from '@/utilities/tokenTools';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',
      meta: { public: true }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(
        /* webpackChunkName: "Login" */
        '@/views/users/Login.vue'),
      meta: { public: true }
    },
    {
      path: '/shipments',
      name: 'shipments',
      // component: ShipmentList,
      component: () => import(
        /* webpackChunkName: "ShipmentList" */
        '@/views/shipments/List.vue'),
      meta: { public: false }
    },
    {
      path: '/inquiry/new/:id?',
      name: 'inquiryNew',
      // component: NewInquiry
      component: () => import(
        /* webpackChunkName: "NewInquiry" */
        '@/views/inquiries/New.vue')
    },
    {
      path: '/shipments/:id',
      // component: ShipmentMain,
      component: () => import(
        /* webpackChunkName: "ShipmentMain" */
        '@/views/shipments/Main.vue'),
      redirect: 'shipments/:id/activity',
      children: [
        {
          path: 'activity',
          name: 'shipmentActivities',
          // component: ShipmentActivities
          component: () => import(
            /* webpackChunkName: "ShipmentActivities" */
            '@/views/shipments/Activities.vue')
        },
        {
          path: 'details',
          name: 'shipmentDetails',
          // component: ShipmentDetails
          component: () => import(
            /* webpackChunkName: "ShipmentDetails" */
            '@/views/shipments/Details.vue')
        },
        {
          path: 'documents',
          component: () => import(
            /* webpackChunkName: "ShipmentDocuments" */
            '@/views/shipments/documents/Main.vue'),
          children: [
            {
              path: '',
              name: 'shipmentDocuments',
              component: () => import(
                /* webpackChunkName: "ShipmentDocuments" */
                '@/views/shipments/documents/List.vue')
            },
            {
              path: ':document_id/edit',
              name: 'shipmentDocumentForm',
              component: () => import(
                /* webpackChunkName: "ShipmentDocumentForm" */
                '@/views/shipments/documents/Form.vue')
            },
            {
              path: ':document_id/preview',
              name: 'shipmentDocumentPreview',
              component: () => import(
                /* webpackChunkName: "ShipmentDocumentForm" */
                '@/views/shipments/documents/Preview.vue')
            }
          ]
        },
        {
          // deprecated route
          path: 'routes',
          name: 'shipmentRoutes',
          redirect: 'milestones'
        },
        {
          path: 'invoice',
          name: 'shipmentInvoice',
          // component: ShipmentQuote
          component: () => import(
            /* webpackChunkName: "ShipmentQuote" */
            '@/views/shipments/Quote.vue')
        },
        {
          path: 'tasks',
          name: 'shipmentTasks',
          component: () => import(
            /* webpackChunkName: "ShipmentTasks" */
            '@/views/shipments/Tasks.vue')
        },
        {
          path: 'attachments',
          name: 'shipmentAttachments',
          component: () => import(
            /* webpackChunkName: "Files" */
            '@/views/Files.vue')
        },
        {
          path: 'order',
          name: 'shipmentOrderDetails',
          // component: ShipmentOrderDetails
          component: () => import(
            /* webpackChunkName: "ShipmentOrderDetails" */
            '@/views/shipments/OrderDetails.vue')
        },
        {
          path: 'insurance',
          name: 'shipmentInsurance',
          // component: Insurance
          component: () => import(
            /* webpackChunkName: "ShipmentInsurance" */
            '@/views/shipments/Insurance.vue')
        },
        {
          path: 'naccs',
          name: 'shipmentNaccs',
          // component: Naccs
          component: () => import(
            /* webpackChunkName: "ShipmentNaccs" */
            '@/views/shipments/Naccs.vue')
        },
        {
          path: 'milestones',
          name: 'shipmentMilestones',
          // component: Milestones
          component: () => import(
            /* webpackChunkName: "ShipmentMilestones" */
            '@/views/shipments/Milestones.vue')
        },
        {
          path: 'channels',
          name: 'shipmentChannels',
          // component: Channels
          component: () => import(
            /* webpackChunkName: "Channels" */
            '@/views/Channels.vue')
        }
      ]
    },
    {
      path: '/inquiries',
      name: 'inquiries',
      // component: InquiryList
      component: () => import(
        /* webpackChunkName: "InquiryList" */
        '@/views/inquiries/List.vue')
    },
    {
      path: '/inquiries/:id',
      // component: InquiryMain,
      component: () => import(
        /* webpackChunkName: "InquiryMain" */
        '@/views/inquiries/Main.vue'),
      redirect: 'inquiries/:id/quote',
      children: [
        {
          path: 'quote',
          name: 'inquiryQuote',
          // component: InquiryQuote
          component: () => import(
            /* webpackChunkName: "InquiryQuote" */
            '@/views/inquiries/Quote.vue')
        },
        {
          path: 'quotes',
          name: 'inquiryQuotesCalculator',
          // component: InquiryQuotesCalculator
          component: () => import(
            /* webpackChunkName: "InquiryQuotesCalculator" */
            '@/views/inquiries/QuotesCalculator.vue')
        },
        {
          path: 'details',
          name: 'inquiryDetails',
          // component: InquiryDetails
          component: () => import(
            /* webpackChunkName: "InquiryDetails" */
            '@/views/inquiries/Details.vue')
        },
        {
          path: 'tasks',
          name: 'inquiryTasks',
          component: () => import(
            /* webpackChunkName: "InquiryTasks" */
            '@/views/shipments/Tasks.vue')
        },
        {
          path: 'attachments',
          name: 'inquiryAttachments',
          component: () => import(
            /* webpackChunkName: "Files" */
            '@/views/Files.vue')
        },
        {
          path: 'channels',
          name: 'inquiryChannels',
          // component: Channels
          component: () => import(
            /* webpackChunkName: "Channels" */
            '@/views/Channels.vue')
        },
        // old route to keep existing links working
        {
          path: 'comments',
          name: 'inquiryComments',
          redirect: 'channels'
        }
      ]
    },
    {
      path: '/bills',
      name: 'bills',
      redirect: 'bills/list',
      component: () => import(
        /* webpackChunkName: "Bill" */
        '@/views/bills/Main.vue'),
      children: [
        {
          path: 'list',
          name: 'billsList',
          component: () => import(
            /* webpackChunkName: "Bill" */
            '@/views/bills/List.vue')
        },
        {
          path: 'new',
          name: 'billNew',
          component: () => import(
            /* webpackChunkName: "Bill" */
            '@/views/bills/New.vue')
        }
      ]
    },
    {
      path: '/bills/:id',
      name: 'billDetails',
      component: () => import(
        /* webpackChunkName: "BillsDetails" */
        '@/views/bills/Details.vue')
    },
    {
      path: '/bills/:id/edit',
      name: 'billEdit',
      component: () => import(
        /* webpackChunkName: "BillsEdit" */
        '@/views/bills/Edit.vue')
    },
    {
      path: '/customers',
      name: 'customers',
      // component: CustomersList
      component: () => import(
        /* webpackChunkName: "CustomersList" */
        '@/views/customers/List.vue')
    },
    {
      path: '/customers/:id',
      // component: CustomerMain,
      component: () => import(
        /* webpackChunkName: "CustomerMain" */
        '@/views/customers/Main.vue'),
      redirect: '/customers/:id/details',
      children: [
        {
          path: 'details',
          name: 'customerDetail',
          // component: Details
          component: () => import(
            /* webpackChunkName: "CustomerDetail" */
            '@/views/customers/Detail.vue')
        },
        {
          path: 'staffs',
          name: 'customerStaffs',
          // component: CustomerStaffs
          component: () => import(
            /* webpackChunkName: "CustomerStaffs" */
            '@/views/customers/Staffs.vue')
        },
        {
          path: 'addresses',
          name: 'customerAddresses',
          // component: CustomerAddresses
          component: () => import(
            /* webpackChunkName: "CustomerAddresses" */
            '@/views/customers/Addresses.vue')
        },
        {
          path: 'contacts',
          name: 'customerContacts',
          // component: CustomerContacts
          component: () => import(
            /* webpackChunkName: "CustomerContacts" */
            '@/views/customers/Contacts.vue')
        },
        {
          path: 'bank-accounts',
          name: 'customerBankAccounts',
          // component: BankAccounts
          component: () => import(
            /* webpackChunkName: "BankAccounts" */
            '@/views/customers/BankAccounts.vue')
        },
        {
          path: 'inquiries',
          name: 'customerInquiries',
          // component: CustomersInquiries
          component: () => import(
            /* webpackChunkName: "CustomersInquiries" */
            '@/views/customers/Inquiries.vue')
        },
        {
          path: 'shipments',
          name: 'customerShipments',
          // component: CustomersShipments
          component: () => import(
            /* webpackChunkName: "CustomersShipments" */
            '@/views/customers/Shipments.vue')
        },
        {
          path: 'products',
          name: 'customerProducts',
          // component: CustomersProducts
          component: () => import(
            /* webpackChunkName: "CustomersProducts" */
            '@/views/customers/ProductsList.vue')
        }
      ]
    },
    {
      path: '/bill-items',
      name: 'billItems',
      component: () => import(
        /* webpackChunkName: "BillItems" */
        '@/views/BillItems.vue')
    },
    {
      path: '/partners',
      name: 'partners',
      // component: PartnersList
      component: () => import(
        /* webpackChunkName: "PartnersList" */
        '@/views/partners/List.vue')
    },
    {
      path: '/partners/:id?',
      // component: PartnerMain,
      component: () => import(
        /* webpackChunkName: "PartnerMain" */
        '@/views/partners/Main.vue'),
      redirect: '/partners/:id/details',
      children: [
        {
          path: 'details',
          name: 'partnerDetails',
          // component: PartnerDetails
          component: () => import(
            /* webpackChunkName: "PartnerDetails" */
            '@/views/partners/Details.vue')
        },
        {
          path: 'new',
          name: 'partnerNew',
          // component: PartnerDetails,
          component: () => import(
            /* webpackChunkName: "PartnerDetails" */
            '@/views/partners/Details.vue'),
          props: { isCreate: true }
        },
        {
          path: 'members',
          name: 'partnerMembers',
          // component: PartnerMembers
          component: () => import(
            /* webpackChunkName: "PartnerMembers" */
            '@/views/partners/MembersList.vue')
        }
      ]
    },
    {
      path: '/tasks',
      name: 'tasks',
      // component: TasksList
      component: () => import(
        /* webpackChunkName: "TasksList" */
        '@/views/tasks/List.vue')
    },
    {
      path: '/users/profile',
      name: 'profile',
      // component: Profile
      component: () => import(
        /* webpackChunkName: "Profile" */
        './views/users/Profile.vue')
    },
    {
      path: '/notifications',
      name: 'notifications',
      // component: Notifications
      component: () => import(
        /* webpackChunkName: "Notifications" */
        '@/views/Notifications.vue')
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: () => import(
        /* webpackChunkName: "Calculator" */
        '@/views/Calculator.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      // component: Settings
      component: () => import(
        /* webpackChunkName: "Settings" */
        '@/views/users/Settings.vue')
    }
  ]
});

// New Tab Link stuff
const OPEN_LINK_NEW_TAB = 'link_new_tab';

router.beforeEach((to, from, next) => {
  if (getUserToken()) {
    extendTokenExpiration();
    store.dispatch('User/userInit');

    if (to.name === 'login') {
      next({ name: 'shipments' });
      return;
    }
    store.dispatch('Alert/clearAlert');
    // if links are to be open in new tab
    if (sessionStorage.getItem(OPEN_LINK_NEW_TAB) === 'true') {
      const shipmentActivities = from.name === 'shipments' && to.name === 'shipmentActivities';
      const shipmentChannels = from.name === 'shipments' && to.name === 'shipmentChannels';
      const shipmentTasks = from.name === 'shipments' && to.name === 'shipmentTasks';
      const inquiryTasks = from.name === 'inquiries' && to.name === 'inquiryTasks';
      const inquiryDetails = from.name === 'inquiries' && to.name === 'inquiryDetails';
      const inquiryChannels = from.name === 'inquiries' && to.name === 'inquiryChannels';
      // then check if route is a main list
      if (shipmentActivities || shipmentChannels || shipmentTasks ||
        inquiryDetails || inquiryChannels || inquiryTasks) {
        const routeData = router.resolve(to);
        window.open(routeData.href, '_blank');
        // no next because it's done in a new tab
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.public)) {
    next();
  } else {
    store.dispatch('Alert/addAlert', { type: 'error', message: 'Login required' });
    next({ path: '/login', query: { redirect: to.fullPath } });
  }
});

router.afterEach(() => {
  // Timestamp in the url is used to bypass the browser's cache
  axios.head(`/?${new Date().getTime()}`).then((response) => {
    store.dispatch('App/updateEtag', response.headers.etag);
  });
});

export default router;
